
import { BestellungFiliale } from "mangdto"
import RestPaths from "@/util/rest_paths"
import Vue from "vue"
import Component from "vue-class-component"
import { Prop } from "vue-property-decorator"

@Component
export default class FilialeHeader extends Vue {
  @Prop()
  filiale: BestellungFiliale

  getBaseStyle() {
    if (this.filiale == null) return
    var result =
      'background-image: url("' +
      RestPaths.imageBasePath +
      this.filiale.bannerId +
      '_cropped.jpg");background-size: cover'

    return result
  }

  getLogoStyle() {
    if (this.filiale == null) return
    return (
      'background-image: url("' +
      RestPaths.imageBasePath +
      this.filiale.bildId +
      '_klein.jpg");corner-radius:50%;width:100%;height:100%;background-size:contain'
    )
  }

  berechneBild() {
    if (this.filiale == null || this.filiale.bildId == null) return
    return RestPaths.imageBasePath + this.filiale.bildId + "_klein.jpg"
  }
}
